import { AccordionItem as AccordionItemCore } from '@studiometa/ui';

/**
 *  component
 */
export default class AccordionItem extends AccordionItemCore {
  /**
   * Component Configuration
   */
  static config = {
    name: 'AccordionItem',
    options: {
      closeOthers: {
        type: Boolean,
        default: false,
      },
    },
  };

  /**
   * Open an item.
   */
  async open() {
    if (this.$options.isOpen) {
      return;
    }

    // Fermer tous les autres items de l'accordéon
    this.$parent.$children.AccordionItem.forEach((item) => {
      if (item !== this && item.$options.isOpen) {
        item.close();
      }
    });

    this.$log('open');
    this.$emit('open');

    this.$options.isOpen = true;
    this.updateAttributes(this.$options.isOpen);
  }

  /**
   * Close an item.
   */
  async close() {
    if (!this.$options.isOpen) {
      return;
    }
    this.$log('close');
    this.$emit('close');
    this.$options.isOpen = false;
    this.updateAttributes(this.$options.isOpen);
  }
}
